import React from 'react';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import FontIcon from 'material-ui/FontIcon';
import Styles from './styles';
import { CURRENT_THEME } from '../../../../config/index';
import { injectIntl } from 'react-intl';
import { Switch, FormGroup, FormControlLabel, styled } from '@material-ui/core';
import {
  isAdminMode,
  setLoginMode,
  hasDualLoginAccess
} from '../../../../utils/session-util';
import { white } from 'material-ui/styles/colors';

const StyledSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#EF6A00',
      '& + .MuiSwitch-track': {
        backgroundColor: 'white',
        opacity: 1,
        border: 0
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    }
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeMode = this.onChangeMode.bind(this);
  }
  onChangeMode(event) {
    setLoginMode(event.target.checked);
    this.props.changeMode(event.target.checked);
  }

  render() {
    const { navDrawerOpen, handleChangeRequestNavDrawer, signOut } = this.props;

    const style = Styles(CURRENT_THEME);

    return (
      <div>
        <AppBar
          style={{
            ...style.appBar,
            paddingLeft: navDrawerOpen ? 250 : 0
          }}
          iconElementLeft={
            <IconButton
              iconStyle={style.iconButton}
              style={style.menuButton}
              onClick={handleChangeRequestNavDrawer}
            >
              <FontIcon
                color={CURRENT_THEME.appBarMenuButtonColor}
                className="material-icons"
              >
                menu
              </FontIcon>
            </IconButton>
          }
          iconElementRight={
            <div style={style.iconsRightContainer}>
              {hasDualLoginAccess() ? (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <StyledSwitch
                        onChange={this.onChangeMode}
                        checked={isAdminMode()}
                      />
                    }
                    label={this.props.intl.formatMessage({ id: 'user.ADMIN' })}
                    color={white}
                  />
                </FormGroup>
              ) : null}
              <IconMenu
                color={CURRENT_THEME.appBarMenuButtonColor}
                iconButtonElement={
                  <IconButton>
                    <FontIcon
                      color={CURRENT_THEME.appBarMenuButtonColor}
                      className="material-icons"
                    >
                      power_settings_new
                    </FontIcon>
                  </IconButton>
                }
                targetOrigin={{
                  horizontal: 'right',
                  vertical: 'top'
                }}
                anchorOrigin={{
                  horizontal: 'right',
                  vertical: 'top'
                }}
              >
                <MenuItem
                  primaryText={this.props.intl.formatMessage({ id: 'sign_out' })}
                  onClick={signOut}
                />
              </IconMenu>
            </div>
          }
        />
      </div>
    );
  }
}

Header.propTypes = {
  navDrawerOpen: PropTypes.bool,
  handleChangeRequestNavDrawer: PropTypes.func,
  signOut: PropTypes.func
};

export default injectIntl(Header);
